{
    "onetoone": {
        "Hepsi": "Alle",
        "Baslik": "One to One",
        "Kullanici": "Gebruiker",
        "Tarih": "Datum",
        "Durum": "Status",
        "Yil": "Jaar",
        "Ay": "Maand",
        "Gorus": "Mening",
        "Not": "Notitie",
        "HedefRandevu": "Doelafspraak",
        "YapilanRandevu": "Werkelijke Afspraak",
        "HedefReferans": "Doelreferentie",
        "YapilanReferans": "Werkelijke Referentie",
        "Urun": "Product",
        "Hedef": "Doel",
        "Yapilan": "Gedaan",
        "Temizle": "Wissen",
        "Arama": "Zoeken",
        "Ara": "Zoeken",
        "Kapat": "Sluiten",
        "Kaydet": "Opslaan",
        "KaydetKapat": "Opslaan en Sluiten",
        "Yenile": "Vernieuwen",
        "YeniEkle": "Nieuwe Toevoegen",
        "Olustur": "Maken",
        "Seciniz": "Selecteer",
        "Bekliyor": "Wachten",
        "GorusAldi": "Mening Ontvangen",
        "Tamamlandi": "Voltooid",
        "Iptal": "Annuleren",
        "EminMisiniz": "Weet u het zeker?",
        "SilmeMesaj": "U kunt dit niet ongedaan maken!",
        "Sil": "Verwijderen"
    }
}
